import { render } from "./DettaglioAttivitaTimesheet.vue?vue&type=template&id=8ad73d44&ts=true"
import script from "./DettaglioAttivitaTimesheet.vue?vue&type=script&lang=ts"
export * from "./DettaglioAttivitaTimesheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__